// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-send-email__subheader[data-v-46b2dd48]{text-align:left;margin-bottom:10px;color:#43454b}.modal-send-email__inputs[data-v-46b2dd48]{color:#000}.modal-send-email__error[data-v-46b2dd48]{color:red}", ""]);
// Exports
module.exports = exports;
